import { footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-10 pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950 font-heading font-black text-lg">
                黑
              </span>
              <span className="font-heading font-black text-xl md:text-2xl tracking-wide">黑料爆料</span>
            </div>
            <p className="mt-5 max-w-md font-body text-sm leading-7 text-background-50/75">
              以证据式整理为核心，把实锤、聊天记录、截图、录音按事件归组，让每份材料都能回到原始内容，
              再去判断事情的来龙去脉。
            </p>
            <a
              href="#subscribe"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-3 font-label text-sm text-secondary-950 hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-notification-3-line text-base" aria-hidden="true"></i>
              订阅材料更新
            </a>
          </div>

          {footerColumns.map((column) => (
            <div key={column.id} className="lg:col-span-2">
              <h4 className="font-heading font-bold text-sm text-background-50">{column.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="font-label text-sm text-background-50/70 hover:text-accent-300 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div id="disclaimer" className="mt-12 md:mt-16 rounded-lg border border-background-50/15 p-5 md:p-6">
          <h4 className="font-heading font-bold text-sm text-background-50">内容边界声明</h4>
          <p className="mt-3 max-w-4xl font-body text-xs md:text-sm leading-6 text-background-50/70">
            本站仅做材料的整理、归组与来源标注，不对事件下结论，也不代表对任何一方的立场。
            所有材料均保留其原始语境，请结合完整上下文自行判断；如对某份材料的来源标注或使用有异议，可通过订阅邮箱回复告知，我们会复核来源说明。
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-label text-xs text-background-50/60">
            © {year} 黑料爆料 · 证据式整理与材料归组
          </p>
          <p className="font-label text-xs text-background-50/60">
            截图来源标注 · 聊天记录保留时间戳 · 录音附文字转写
          </p>
        </div>
      </div>
    </footer>
  );
}